import { Presentation, SlideMasterProps } from '@features/powerpoint';
import { DEFAULT_FONT } from './constants';

export const SLIDE_WIDTH = 13.33;
const SLIDE_HEIGHT = 7.5;
const LAYOUT = 'CUSTOM_WIDESCREEN';

export const createSharedPresentationConfigV2 = (
  slideMasters: SlideMasterProps[]
): Presentation => {
  return {
    slideMasters,
    layout: {
      name: LAYOUT,
      width: SLIDE_WIDTH,
      height: SLIDE_HEIGHT,
    },
    theme: { headFontFace: DEFAULT_FONT, bodyFontFace: DEFAULT_FONT },
  };
};
